import styled, { css } from 'styled-components';
import { Button as AntButton } from 'antd';
import { Severity, ButtonType } from '@app/interfaces/interfaces';
import { defineColorBySeverity, defineColorByButtonType, defineBGColorByButtonType, defineBorderColorByButtonType, defineFontColorByButtonType } from '@app/utils/utils';

interface BtnProps {
  $severity?: Severity;
  $buttontype?: ButtonType;
  $noStyle?: boolean;
  $round?: boolean;
}

export const Button = styled(AntButton)<BtnProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;

  ${(props) =>
    props.$noStyle &&
    css`
      width: unset;
      padding: 0;
      height: unset;
    `}

  ${(props) =>
    props.$round &&
      css`
  border-radius: 1.5rem;
    font-weight: 550;
    font-size: 16px; 
    padding: 1.2rem;
    height: 44px;
    `}

  &[disabled],
  &[disabled]:active,
  &[disabled]:focus,
  &[disabled]:hover {
    color: var(--disabled-color);
  }
  ${(props) =>

    !props.danger &&
    css`

      ${props.$severity &&
      css`
        box-shadow: none;
        text-shadow: none;

        background: rgba(${defineColorBySeverity(props.$severity, true)}, 0.2);
        border-color: ${defineColorBySeverity(props.$severity)};
        color: ${defineColorBySeverity(props.$severity)};

        &:hover {
          background: var(--background-color);
          border-color: rgba(${defineColorBySeverity(props.$severity, true)}, 0.9);
          color: rgba(${defineColorBySeverity(props.$severity, true)}, 0.9);
        }

        &:focus {
          background: var(--background-color);
          border-color: rgba(${defineColorBySeverity(props.$severity, true)}, 0.9);
          color: rgba(${defineColorBySeverity(props.$severity, true)}, 0.9);
        }
      `}

      ${props.$buttontype &&
        css`
          box-shadow: none;
          text-shadow: none;

          background: rgba(${defineBGColorByButtonType(props.$buttontype, true)}, ${props.$buttontype === 'button' ? 0.8 : 1});
          border-color: ${defineBorderColorByButtonType(props.$buttontype)};
          color: ${defineFontColorByButtonType(props.$buttontype)};
  
          &:hover {
            background: var(--background-color);
            border-color: rgba(${defineColorByButtonType(props.$buttontype, true)}, 0.9);
            color: rgba(${defineColorByButtonType(props.$buttontype, true)}, 0.9);
          }
  
          &:focus {
            background: var(--background-color);
            border-color: rgba(${defineColorByButtonType(props.$buttontype, true)}, 0.9);
            color: rgba(${defineColorByButtonType(props.$buttontype, true)}, 0.9);
          }
        `}

      ${props.type === 'text' &&
      css`
        &:hover {
          background: transparent;
          color: var(--secondary-color);
        }
      `}

      ${props.type === 'ghost' &&
      css`
        &:hover {
          color: var(--secondary-color);
          border-color: var(--secondary-color);
        }
      `}

      ${props.type === 'primary' &&
      css`
        background: var(--primary-color);
        &:hover {
          background: var(--secondary-color);
          border-color: var(--secondary-color);
        }
      `}

      ${props.type === 'link' &&
      css`
        & span,
        a {
          text-decoration: underline;
        }
      `};
    `}
`;
